export default __webpack_public_path__ + "static/media/logout-new.a86e609a.svg";